import { render, staticRenderFns } from "./LvPopupChooseFile.vue?vue&type=template&id=384f98ac"
import script from "./LvPopupChooseFile.vue?vue&type=script&lang=js"
export * from "./LvPopupChooseFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports